/**
 * Проверяет вхождение координат в зоны доставки
 * @param lat
 * @param lon
 * @returns {boolean}
 */
export const isAddressIncludedInDeliveryArea = async function (lat, lon) {
    return BX.ajax.runComponentAction(
        'orteka:api.geo',
        'isAddressIncludedInDeliveryArea',
        {
            mode: 'ajax',
            data: {
                lat,
                lon
            }
        }
    )
}